import React from "react";
import { Box, Paper, TextField, Typography } from "@mui/material";

function TeaxtareaField({
  name,
  placeholder,
  size,
  value,
  onChange,
  state,
  disable,
  required,
  rows,
  sx,
  onKeyDown,
  maxLength
}) {
  return (
    <Box>
      <TextField
        disabled={disable}
        error={
          state?.errorStatus && state?.errorStatus[name] === true ? true : false
        }
        id={name}
        name={name}
        label={placeholder}
        multiline
        variant="outlined"
        size={size}
        fullWidth
        value={value}
        required={required}
        onChange={onChange}
        rows={rows}
        onKeyDown={onKeyDown}
        InputProps={{
          classes: {
            input: "custom-scrollbar", // Your custom class
          },
        }}
        inputProps={{
        maxLength: maxLength
      }}
      // sx={{
      //   ".css-1d3z3hw-MuiOutlinedInput-notchedOutline": {
      //     borderColor: "input.border",
      //   },
      //   ".css-wgai2y-MuiFormLabel-asterisk": {
      //     color: "danger.main",
      //   },
      //   ".MuiInputBase-root": {
      //     height: "100%",
      //   },
      //   height: "100%",
      // }}
      />
      <Typography
        sx={{
          marginTop: "2px",
          marginLeft: "10px",
          marginBottom: "0px",
          fontSize: "11px",
          color: "danger.main",
        }}
      >
        {state?.errorFields[name]}
      </Typography>
    </Box>
  );
}

export default TeaxtareaField;
